
import { Helmet } from 'react-helmet-async';
import { HeaderSection } from '../../components/HeaderSection';
import { HomeInfoSection } from '../../components/HomeInfoSection';

const Home = () => {

  return (
    <>
      <Helmet>
        <title>Affordable Vehicle Rentals for Trips | Home</title>
        <meta
          name="description"
          content="Rent clean, spacious, and affordable vehicles for group trips, events, and airport transfers. Book online in minutes."
        />
      </Helmet>
      <div className='w-full'>
        <HeaderSection />
        <HomeInfoSection />
      </div>
    </>

  )
}

export default Home
